import { render, staticRenderFns } from "./AlternativesView.vue?vue&type=template&id=61b98e32"
import script from "./AlternativesView.vue?vue&type=script&lang=js"
export * from "./AlternativesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports